module.exports = __webpack_public_path__ + "static/media/no-circle-brown.0a5720d0.png";